import Cookies from 'js-cookie'

const CookieKey = 'xumm@r_tOk3n'

export const cookie = {
    getToken() {
        let _cookieToken = Cookies.get(CookieKey);
        
        return _cookieToken === 'undefined' ? false : _cookieToken;
    },
    setToken(token) {
        return Cookies.set(CookieKey, token)
    },
    removeToken() {
        return Cookies.remove(CookieKey)
    }
};